export const LANG_CHANGE = 'language-change';
